
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import {ErrorService, EventService} from '..';

import { ClientfileResponse, Clientfile } from '../models/clientfile';
import { ConfigService } from './config.service';
import { ReleaseBundleResponse, ReleaseBundle, CreateReleaseBundleRequest, UpdateReleaseBundleRequest } from '../models/releasebundle';


@Injectable({providedIn: 'root'})
export class ReleaseBundleService {

    private releaseBundleURL = ConfigService.getApiEndpoint() + 'v1/releasebundle/';

    constructor(
        private http: HttpClient,
        private eventService: EventService,
        private error: ErrorService
    ) { }

    search(query: any): Observable<ReleaseBundleResponse> {
        return this.http.get<ReleaseBundleResponse>(this.releaseBundleURL + 'search', { params: query }).pipe(
            catchError(this.error.handleError('searchFiles', null))
        );
    }

    getOne(id: string): Observable<ReleaseBundle> {
        return this.http.get<ReleaseBundle>(this.releaseBundleURL + id).pipe(
            catchError(this.error.handleError('getOneReleaseBundle', null))
        );
    }

    getAllByStati(status?: string[]): Observable<ReleaseBundle[]> {
        return this.http.get<ReleaseBundle>(this.releaseBundleURL, (status ? {params: {status: status}} :  {})).pipe(
            catchError(this.error.handleError('getReleaseBundleByStatus', null))
        );
    }

    getAllSelectableForProjectBranch(): Observable<ReleaseBundle[]> {
        return this.http.get<ReleaseBundle>(this.releaseBundleURL, {params: {status: ['A', 'QA']}}).pipe(
            catchError(this.error.handleError('getAllSelectableForProjectBranch', null))
        );
    }

    create(releaseBundle: CreateReleaseBundleRequest): Observable<ReleaseBundle> {
        return this.http.post<ReleaseBundle>(this.releaseBundleURL, releaseBundle).pipe(
            tap(_ => this.eventService.addAlert(`created releaseBundle`)),
            catchError(this.error.handleError('createReleaseBundle', null))
        );
    }

    update(releaseBundle: UpdateReleaseBundleRequest, id: string): Observable<ReleaseBundle> {
        return this.http.put<ReleaseBundle>(this.releaseBundleURL + id, releaseBundle).pipe(
            tap(_ => this.eventService.addAlert(`updated releaseBundle: ${id}`)),
            catchError(this.error.handleError('updatedReleaseBundle', null))
        );
    }

    getLatestBundleVersion(): Observable<string> {
        return this.http.get<string>(this.releaseBundleURL + 'latestversion').pipe(
            catchError(this.error.handleError('getLatestBundleVersion', null))
        );
    }

    getEmptyBundle(): Observable<ReleaseBundle> {
        return this.http.get<ReleaseBundle>(this.releaseBundleURL + 'emptybundle').pipe(
            catchError(this.error.handleError('getNewBundleVersion', null))
        );
    }

}
